import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { AdminApp } from '@acorns/admin-framework-binding'
import posed from 'react-pose'

import { preload } from './preload'
import { track } from '../../utils/log'
import { trackAdminPortalTileTappedPayload } from '../../../generated/trackingEvents'
import { useAuthContext } from '../../contexts/auth'

type Props = {
  app: Partial<AdminApp>
} & RouteComponentProps

const animation = {}

const Container = styled(posed.div(animation) as any)`
  align-items: center;
  background: #fff;
  border-radius: 25px;
  box-shadow: 0px 0px 19px 3px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: AvenirNext-DemiBold;
  height: 196px;
  justify-content: center;
  transition: box-shadow 300ms;

  &:hover {
    box-shadow: 0px 0px 19px 3px rgba(0, 0, 0, 0.2);
  }
`

const Name = styled.div`
  color: rgb(54, 63, 65);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;
  line-height: 26px;
`

const Badge = styled.div`
  align-items: center;
  background: rgb(116, 201, 71);
  border-radius: 50%;
  color: rgb(255, 255, 255);
  display: flex;
  font-size: 40px;
  font-weight: 600;
  height: 100px;
  justify-content: center;
  letter-spacing: -0.2px;
  margin-bottom: 20px;
  width: 100px;
`

const Version = styled.div`
  color: #afafaf;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
`

const Tile: React.SFC<Props> = (props) => {
  const { adminUser } = useAuthContext()

  const onMouseEnter = () => {
    preload(props.app.source)
  }

  const onClick = () => {
    if (adminUser?.id) {
      const [eventName, payload] = trackAdminPortalTileTappedPayload({ title: props.app.title })
      track(eventName, payload, adminUser?.id)
    }

    props.history.push(props.app.rootPath);
  }

  const name = props.app.title.charAt(0).toUpperCase()
  const version = props.app.version

  return (
    <Container onMouseEnter={onMouseEnter} onClick={onClick}>
      <Version>v{version}</Version>
      <Badge>{name}</Badge>
      <Name>{props.app.title}</Name>
    </Container>
  )
}

export default withRouter(Tile)
